import React, { FC, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

type Props = {
  onRefresh?: () => Promise<void>;
  onPrint?: any;
  onExportPdf?: any;
  onExportExcel?: () => void;
  onPrintBlank?: () => void;
  printLoading?: boolean;
  exportPdfLoading?: boolean;
  exportExcelLoading?: boolean;
};

const TooltipOption: FC<Props> = (props) => {
  const {
    onRefresh,
    onPrint,
    onExportPdf,
    onExportExcel,
    onPrintBlank,
    printLoading,
    exportPdfLoading,
    exportExcelLoading,
  } = props;

  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await onRefresh?.();
    setIsRefreshing(false);
  };

  return (
    <>
      <div className="pe-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
        >
          <Link
            to="#"
            onClick={handleRefresh}
            className="btn btn-outline-light bg-white btn-icon me-1"
          >
            <i
              className={`ti ti-refresh ${isRefreshing ? "rotate-icon" : ""}`}
            />
          </Link>
        </OverlayTrigger>
      </div>
      <div className="pe-1 mb-2">
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">{printLoading ? "Preparing..." : "Print"}</Tooltip>}
        >
          <button
            onClick={onPrint ?? onExportPdf}
            type="button"
            className="btn btn-outline-light bg-white btn-icon me-1"
            disabled={printLoading}
          >
            {printLoading
              ? <span className="spinner-border spinner-border-sm" />
              : <i className="ti ti-printer" />}
          </button>
        </OverlayTrigger>
      </div>
      {onPrintBlank && (
        <div className="pe-1 mb-2">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-print-blank">Print blank sheet</Tooltip>}
          >
            <button
              onClick={onPrintBlank}
              type="button"
              className="btn btn-outline-light bg-white btn-icon me-1"
            >
              <i className="ti ti-notes" />
            </button>
          </OverlayTrigger>
        </div>
      )}
      <div className="dropdown me-2 mb-2">
        <Link
          to="#"
          className="dropdown-toggle btn btn-light fw-medium d-inline-flex align-items-center"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
        >
          <i className="ti ti-file-export me-2" />
          Export
        </Link>
        <ul className="dropdown-menu dropdown-menu-end p-3">
          <li>
            <Link
              to="#"
              className={`dropdown-item rounded-1 ${exportPdfLoading ? "disabled text-muted" : ""}`}
              onClick={exportPdfLoading ? undefined : onExportPdf}
            >
              {exportPdfLoading
                ? <span className="spinner-border spinner-border-sm me-1" />
                : <i className="ti ti-file-type-pdf me-1" />}
              {exportPdfLoading ? "Preparing PDF..." : "Export as PDF"}
            </Link>
          </li>
          <li>
            <Link
              to="#"
              className={`dropdown-item rounded-1 ${exportExcelLoading ? "disabled text-muted" : ""}`}
              onClick={exportExcelLoading ? undefined : onExportExcel}
            >
              {exportExcelLoading
                ? <span className="spinner-border spinner-border-sm me-1" />
                : <i className="ti ti-file-type-xls me-1" />}
              {exportExcelLoading ? "Preparing Excel..." : "Export as Excel"}
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default TooltipOption;
